import { LiveChatPlatform } from '../app/types/enum';

export function isTransferBetweenPlatforms(text: string): boolean {
  // TODO - exact condition to be added
  return (
    text.includes(LiveChatPlatform.cx) || text.includes(LiveChatPlatform.dx)
  );
}
